import { Component, Inject, OnInit } from '@angular/core';
import { AppService } from '../../../shared/services/app.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { DashboardMetadata } from '../../../../API';

@Component({
  selector: 'app-view-dashboards',
  templateUrl: './view-dashboards.component.html',
  styleUrl: './view-dashboards.component.scss',
})
export class ViewDashboardsComponent implements OnInit {
  dashboard!: DashboardMetadata;

  constructor(
    private appService: AppService,
    @Inject(NZ_MODAL_DATA) public data: any,
    private nzModalRef: NzModalRef,
  ) {}
  ngOnInit(): void {
    this.dashboard = this.data?.dashboardData;
  }

  getDashboardImage(): string {
    const dashboard = this.dashboard;
    return `${this.appService.domainUrl}/images/dashboard/${dashboard.orgId}/${dashboard.dashboardId}/dashboard.png?v=${dashboard.lastModifiedAt}`;
  }

  close(): void {
    this.nzModalRef.close(null);
  }
}
